/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookOpenIcon20Solid = forwardRef('BookOpenIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.25 3.454C7.12 1.855 4.092 1.9 2.359 2.097 1.555 2.187 1 2.888 1 3.697v10.38c0 1.12 1.046 1.977 2.165 1.945 1.717-.048 4.097.21 5.772 1.691.094.083.2.152.313.208V3.454Z" }),
        React.createElement("path", { d: "M10.75 17.925a1.4 1.4 0 0 0 .317-.209c1.68-1.482 4.053-1.74 5.766-1.694 1.12.031 2.167-.827 2.167-1.947V3.697c0-.809-.555-1.51-1.359-1.6-1.733-.197-4.76-.242-6.891 1.357v14.471Z" })));
});
